<p-toast
  *ngFor="let config of toastConfigs"
  [position]="position"
  [key]="config.key"
  [styleClass]="styleClass"
>
  <ng-template let-message pTemplate="message">
    <div class="flex items-center gap-2">
      <span class="max-w-72 truncate">
        <img [src]="config.icon" [class]="config.iconWidth + ' mr-1'" />
        {{ message.summary }}
      </span>
    </div>
  </ng-template>
</p-toast>
